import { ResourcePage } from "@/components/resource-page"
import { z } from "zod"
import { Lock } from "lucide-react"

const secretSchema = z.object({
  name: z.string().min(1, "Name is required"),
  value: z.string().min(1, "Value is required"),
  category: z.string().optional(),
  description: z.string().optional(),
})

const secretColumns = [
  { key: "id", type: "text", options: { label: "ID" } },
  { key: "name", type: "text", options: { label: "Name" } },
  { key: "value", type: "text", options: { label: "Value" } },
  { key: "category", type: "text", options: { label: "Category" } },
  { key: "description", type: "text", options: { label: "Description" } },
  { key: "created_at", type: "date", options: { label: "Created" } },
]

const secretFormFields = [
  { name: "name", label: "Name", type: "text", placeholder: "Enter secret name" },
  { name: "value", label: "Value", type: "text", placeholder: "Enter secret value" },
  { name: "category", label: "Category", type: "text", placeholder: "Enter category" },
  { name: "description", label: "Description", type: "text", placeholder: "Enter description" },
]

export default function SecretsPage() {
  return (
    <ResourcePage
      resource="secrets"
      title="Secrets"
      icon={Lock}
      columns={secretColumns}
      formFields={secretFormFields}
      formSchema={secretSchema}
      searchPlaceholder="Search secrets..."
    />
  )
}
